import React from 'react';
import { Flex, Typo, theme } from '../../../ui';
import { useUser } from '../../auth/hooks';
import styled from 'styled-components';
import { media } from '../../../utils/media';

const WelcomeSection = styled(Flex)`
  background: transparent;
  padding: 24px 0;
  width: 100%;
  ${media.lessThan('bigTablet')} {
    padding: 0;
  }
`;

const Greeting = styled(Typo.MediumText)`
  color: ${theme.colors.NEU_600};
  margin-bottom: 8px;
`;

const UserName = styled(Typo.PageHeader)`
  color: ${theme.colors.NEU_PRIMARY};
  margin-bottom: 4px;
  font-weight: 700;
`;

const Tagline = styled(Typo.Info)`
  color: ${theme.colors.NEU_600};
  margin-top: 12px;
`;

const WelcomeWrapper = styled(Flex)`
  max-width: 40%;
  min-width: 280px;
  ${media.lessThan('tablet')} {
    max-width: 100%;
  }
`;

const WelcomeMessage = ({ role }) => {
  const user = useUser();
  const userName = user?.displayName;

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  const tagLineByRole = {
    teacher: "Here's what's happening with your students today",
    reader: 'Your personalized learning environment. Track your active progress and review your past achievements.',
    owner: "Here's what's happening in your store today",
    editor: "Here's what's happening today",
    accountant: "Here's what's happening today",
    assistant: 'Enjoy your day',
    'dark-admin': 'Enjoy your day',
  };

  return (
    <WelcomeWrapper direction='row' justify='space-between' gap='20'>
      <WelcomeSection direction='column' align='flex-start'>
        <Greeting>{getGreeting()},</Greeting>
        <UserName>{userName}</UserName>
        <Tagline $italic>{tagLineByRole[role]}</Tagline>
      </WelcomeSection>
    </WelcomeWrapper>
  );
};

export default WelcomeMessage;
